import { render, staticRenderFns } from "./ProcessDangerGovern.vue?vue&type=template&id=b65b4902&scoped=true"
import script from "./js/ProcessDangerGovern.js?vue&type=script&lang=js&external"
export * from "./js/ProcessDangerGovern.js?vue&type=script&lang=js&external"
import style0 from "./ProcessDangerGovern.vue?vue&type=style&index=0&id=b65b4902&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65b4902",
  null
  
)

export default component.exports